export default __webpack_public_path__ + "static/link-f83f1a633cc832d3be10d57cfccafc18.png";